export default "__VITE_ASSET__DOI4tWJ4__"